import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, delay, map, tap } from 'rxjs/operators';
import { App1ConfigSettings } from '../models/app1ConfigSettings';
import { App2ConfigSettings } from '../models/app2ConfigSettings';

//https://medium.com/@dneimke/configurable-logging-in-angular-projects-30dd5d999db6
export class LoggingLevel {
  public static None = 'None';
  public static Verbose = 'Verbose';
  public static Info = 'Info';
  public static Warnings = 'Warnings';
  public static Errors = 'Errors';
}

const SETTINGS_LOCATION = "assets/config/config.json";
const SETTINGS_LOCATION_LOCAL = "assets/config/config.local.json";

@Injectable({
  providedIn: 'root',
})
export class ConfigService {

  app1ConfigSettings: App1ConfigSettings
  app2ConfigSettings: App2ConfigSettings

  //General settings should be on ALL CONFIGS
  envName: string;
  loggingLevel: LoggingLevel = LoggingLevel.None;
  production: boolean = false;
  shouldEnforceLogin: boolean = true;
  checkRecaptchaEnabled: any;

  constructor(private http: HttpClient) { }

  Init(initConfigForAppName: string): any {

    return this.loadConfig(initConfigForAppName);

  }

  loadConfig(initConfigForAppName: string): //http: HttpClient,
    //config: ConfigService
    () => Promise<boolean> {

    return (): Promise<boolean> => {

      return new Promise<boolean>((resolve) => {

        this.http

          //we'll always read from this location, but file contacts will be different
          //see postBuildCopyConfigs in package.json
          .get(SETTINGS_LOCATION)
          //.get(SETTINGS_LOCATION_LOCAL)

          .pipe(
            map((c: any) => {

              let initConfigForAppNameWeNowLoaded: string = initConfigForAppName;

              if (initConfigForAppNameWeNowLoaded == "app1") {

                this.app1ConfigSettings = new App1ConfigSettings(c.loggingLevel, c.envName, c.production, c.shouldEnforceLogin, c.checkRecaptchaEnabled)

              } else if (initConfigForAppNameWeNowLoaded == "app2") {

                this.app2ConfigSettings = new App2ConfigSettings(c.loggingLevel, c.envName, c.production, c.shouldEnforceLogin)

              }

              //Set general settings not for app specific since ALL configs
              debugger;
              this.envName = c.envName;
              this.production = c.production;
              this.loggingLevel = c.loggingLevel;
              this.shouldEnforceLogin = c.shouldEnforceLogin;
              this.checkRecaptchaEnabled = c.checkRecaptchaEnabled;
              
              resolve(true);

            }),

            catchError((error: any) => {

              this.loggingLevel = LoggingLevel.None;

              resolve(true);

              return of({});

            })

          )
          .subscribe();
      });

    };

  }

}

